import {
  isHuaxiOrg
} from '@/assets/js/util'

// 泰福利快捷入口
export const taiWelfareSceneEntry1 = [{
    title: '男士体检',
    pic: 'upload/imagelist/ori/d8d53a416f40b1eae2aed326bd974179.png',
    url: 'https://apps.daishutijian.com/wechat/h5#/package-list?for_sex_list=1'
  },
  {
    title: '女士体检',
    pic: 'upload/imagelist/ori/202d5d9e81e2d99f017bc4c1933d3e85.png',
    url: 'https://apps.daishutijian.com/wechat/h5#/package-list?for_sex_list=2'
  },
  {
    title: '父母体检',
    pic: 'upload/imagelist/ori/b5e22b273ec2d9fd3ee683270a74b4b6.png',
    url: 'https://apps.daishutijian.com/wechat/h5#/package-list?package_class=6,7,42,126&sceneEntry=1'
  },
  {
    title: '高端体检',
    pic: 'upload/imagelist/ori/cfc855abb205eb818c96f949dbc9b82d.png',
    url: 'https://apps.daishutijian.com/wechat/h5#/package-list?package_class=129&sceneEntry=2'
  }
]
export const taiWelfareSceneEntry2 = [{
    title: '职场体检',
    desc: '快速便捷预约',
    url: 'https://apps.daishutijian.com/wechat/h5#/package-list?package_class=2,127,129,147&sceneEntry=7&from_index_for_operation=operation50'
  },
  {
    title: '防癌套餐',
    desc: '早检测早预防',
    url: ''
  },
  {
    title: 'HPV疫苗',
    desc: '呵护女性健康',
    url: ''
  }
]
// 帮助与反馈问题
export const problems = [{
    question: '关于体检注意事项',
    answer: [
      '体检前一天清淡饮食，晚10点后禁食、禁水，晚10点前休息。体检当天空腹，禁食水，医院体检中心一般8点上班（部分医院8：30），务必上午10点前（部分医院9：00前）携带身份证到达体检现场登记确认并参加体检，超过规定时间，医院或体检中心有权拒检。',
      '已婚女性例假期间，妇科项目及尿液常规项目等不能检查，该部分项目可在体检前台办理补检手续。',
      `如未能按期体检，请与客服联系（${brandConfig.daishuPhone}）为您改期或退款。`
    ]
  },
  {
    question: '关于体检耗时',
    answer: [
      '通常体检完成所需时间约2到5小时左右，体检时间与体检项目数量成正比。如有特殊项目（如核磁共振、肠胃镜等）可能无法在当天完成，可及时与工作人员沟通确定时间（一般在平台预约的体检，医院会帮助提前预约二次预约项目，尽量约到一天完成所有体检项目，部分会通知改期）。'
    ]
  },
  {
    question: '关于增加体检项目',
    answer: [
      '需要前往体检中心前台办理，并现场缴纳所增加的项目费用（部分新增项目当日可能无法进行，请沟通医院根据个人情况谨慎选择）。'
    ]
  },
  {
    question: '关于退款',
    answer: [
      `体检订单取消后，费用自审核通过后7个工作日内按原路径账户退回。如未到账，请与客服联系（${brandConfig.daishuPhone.replaceAll('-', '')}）进行处理。`
    ]
  },
  {
    question: '关于体检报告相关问题',
    answer: isHuaxiOrg() ? [
      '体检报告出具时间为体检完成后10-15个工作日，可通过“华西二院健康管理中心”官方微信查看您的电子报告。',
      '如需纸质报告，可在前台咨询相关邮寄服务。',
      '报告出具速度与体检项目多少有关，如超过15个工作日未收到体检报告通知，请与客服联系（4000-9751-88）为您查询。'
    ] : [
      '专业体检机构报告将在体检结束后7个工作日后上传。如需纸质报告，请在预约体检时，务必选择纸质体检报告。（备注：纸质报告第一份免费提供，如需邮寄，可在体检时进行登记，体检中心负责邮寄，费用须用户到付）',
      `公立医院体检报告出具时间为体检完成后7-15个工作日，一般只提供纸质报告，部分医院可提供电子报告，体检完成可咨询查看报告方式，如需邮寄，可体检时核实医院是否提供邮寄服务，如可邮寄，费用须用户到付。`,
      '由于用户原因导致报告遗失，需根据医院实际情况而定，可能需补交工本费10-30元不等，或者是无法补打。',
      `报告出具速度与体检项目多少、医院机构不同有关，如超过15个工作日未收到体检报告通知，请与客服联系（${brandConfig.daishuPhone.replaceAll('-', '')}）为您查询。`
    ]
  },
  {
    question: brandConfig.dmi ? '礼品卡相关问题' : '体检所需时间',
    answer: brandConfig.dmi ? [
      '本平台礼品卡是由讯康信息技术（深圳）有限公司发行的，可以并仅限在袋鼠健康平台上购买体检服务。礼品卡兑换后的金额对应为平台钱包余额，在袋鼠健康平台内预约体检，提交订单时可选择使用余额抵扣。假设小袋鼠兑换了500元礼品卡，则此时钱包余额为500元。假设预约了800元的体检，支付时选择余额抵扣，那么小袋鼠还需支付300元现金（800-500=300）。',
      "礼品卡和优惠券可以同时使用，假设小袋鼠兑换了500元的礼品卡+20元的优惠券，预约了800元的体检，支付时选择余额抵扣，那么小袋鼠只需支付280元现金（800-500-20=280）。",
      "目前仅可通过扫码与兑换中心兑换礼品卡。方法一：扫描二维码，进入“袋鼠健康”公众号页面，关注“袋鼠健康”公众号，接收推送消息选择“点击进行激活”，跳转兑换界面，绑定手机号并输入密码进行兑换。方法二：关注“袋鼠健康”公众号，绑定手机号，进入“我的”→“兑换中心”输入卡号及卡密进行兑换。礼品卡与人民币兑换比例为1:1，如：礼品卡面值8000元，可兑换8000元的钱包余额。",
      `请登录袋鼠健康官网（${brandConfig.daishuwebsite}）或致电官方客服热线${brandConfig.daishuwebsitePhone}咨询或购买。礼品卡为不记名卡，请妥善保存以免遗失。礼品卡不能提现，不可转让。`,
      "取消订单，礼品卡所兑换的钱包余额退回个人账号。可在[袋鼠健康]—[个人中心]—[钱包]查询有关礼品卡的使用记录。",
      "礼品卡具有有效期，以卡面有效日期为准，请在有效期内进行兑换与使用。"
    ] : [
      '所有项目参加体检完成耗时约2到5小时左右，如遇体检客户较多或出现排队现象，体检时间与体检项目数量成正比，也不保证所有项目能一天内完成（如有核磁共振、CT、胶囊胃镜等项目）。'
    ]
  },
  {
    question: '关于发票申请',
    answer: [
      '预约完成后如需索取发票，可点击个人中心->我的订单->点击预约订单->进入订单详情页，点击左下方的索取发票，进入填写发票信息页面，按照要求填完发票信息即可。（体检完成后，7-15个工作日左右开具电子发票到预留电子邮箱）'
    ]
  }
]
export const marriedArr = [{
    text: '已婚',
    value: '1'
  },
  {
    text: '未婚',
    value: '2'
  }
]
// 证件类型
export const cardType = [{
    text: '身份证',
    value: '1'
  },
  {
    text: '护照',
    value: '2'
  },
  {
    text: '回乡证',
    value: '3'
  },
  {
    text: '台胞证',
    value: '4'
  },
  {
    text: '其他',
    value: '5'
  }
]
// 订单状态
export const orderConfig = {
  '-1': {
    describe: '未预约',
    class: 'undone',
    changeDate: false,
    toPay: false,
    status: '-1'
  },
  '0': {
    describe: '已取消',
    class: 'fail',
    changeDate: false,
    toPay: false,
    status: '0'
  },
  '1': {
    describe: '已预约，待支付',
    class: 'undone',
    changeDate: true,
    toPay: true,
    status: '1'
  },
  '2': {
    describe: '爽约',
    class: 'fail',
    changeDate: false,
    toPay: false,
    status: '2'
  },
  '3': {
    describe: '审核不通过',
    class: 'fail',
    changeDate: false,
    toPay: false,
    status: '3'
  },
  '4': {
    describe: '支付超时',
    class: 'fail',
    changeDate: false,
    toPay: false,
    status: '4'
  },
  '5': {
    describe: '支付成功',
    class: 'success',
    changeDate: true,
    toPay: false,
    status: '5'
  },
  '6': {
    describe: '待取报告',
    class: 'success',
    changeDate: false,
    toPay: false,
    status: '6'
  },
  '7': {
    describe: '已过期',
    class: 'fail',
    changeDate: false,
    toPay: false,
    status: '7'
  },
  '8': {
    describe: '申请退款中',
    class: 'undone',
    changeDate: false,
    toPay: false,
    status: '8'
  },
  '9': {
    describe: '已退款',
    class: 'success',
    changeDate: false,
    toPay: false,
    status: '9'
  },
  '10': {
    describe: '已申请',
    class: 'undone',
    changeDate: false,
    toPay: false,
    status: '10'
  },
  '11': {
    describe: '确认收到体检报告',
    class: 'undone',
    changeDate: false,
    toPay: false,
    status: '11'
  }
}
export const SEX_ARR = ['未知', '男', '女']
export const MAIL_REPORT_TYPE = [
  '自取报告',
  '电子报告',
  '自取报告',
  '自取报告（支持快递）',
  '企业用户',
  '两者都要',
  '邮寄报告'
]
export const reportWay = [{
    text: '电子报告',
    value: '1'
  },
  {
    text: '无',
    value: '2'
  }
]
export const INVOICE_TYPE = [{
    text: '普通发票(邮费到付)',
    value: '2'
  },
  {
    text: '企业发票(邮费到付)',
    value: '3'
  },
  {
    text: '电子发票',
    value: '4'
  }
]

export const NEW_INVOICE_TYPE = {
  '1': '不开发票',
  '5': '个人发票',
  '6': '企业发票'
}

export const BL_BUY_TIPS = [
  '选择你所需要的对应城市的套餐，购买将生成二维码与卡号卡密',
  `扫描二维码或进入${isWechatSubscription ? '体检平台' : '袋鼠健康'
  } [个人中心] 兑换套餐页面，验证卡号卡密后，可进行该套餐的预约流程`,
  '请不要把该二维码或卡号密码透漏给其他人'
]
export const CARD_STATUS = {
  '0': {
    text: '已取消',
    describe: '已取消'
  },
  '1': {
    describe: '未支付',
    text: '未支付'
  },
  '4': {
    describe: '支付超时',
    text: '支付超时'
  },
  '5': {
    describe: '已支付',
    text: '已支付'
  },
  '6': {
    describe: '已使用',
    text: '已使用'
  },
  '8': {
    describe: '申请退款中',
    text: '申请退款中'
  },
  '9': {
    describe: '已退款',
    text: '已退款'
  }
}
/* medicalcard status 新 体检卡状态 */
export const MEDICALCARD_STATUS = {
  CANCELED: {
    code: 10,
    name: '已取消'
  },
  NOT_PAYED: {
    code: 11,
    name: '待支付'
  },
  OVER_TIME: {
    code: 14,
    name: '支付超时'
  },
  APPLY_REFUND: {
    code: 18,
    name: '申请退款'
  },
  REFUNDED: {
    code: 19,
    name: '已退款'
  },
  NOT_USED: {
    code: 25,
    name: '已支付'
  },
  USED: {
    code: 36,
    name: '已使用'
  },
  GIVING: {
    code: 37,
    name: '赠送中'
  },
  GAVE: {
    code: 38,
    name: '已赠送'
  },
  INVALID: {
    code: 39,
    name: '已失效'
  }
}
/* 体检卡订单列表按钮状态 */
export const MEDICALCARD_BTN_STATUS = {
  UNUSED: {
    code: 1,
    name: '立即使用'
  },
  PAY_AGAIN: {
    code: 2,
    name: '再次购买'
  },
  NOT_PAYED: {
    code: 3,
    name: '立即支付'
  },
  TOGIVE: {
    code: 13,
    name: '赠送'
  }
}
export const SEX_TYPE = [{
    text: '男',
    value: '1'
  },
  {
    text: '女',
    value: '2'
  }
]
// 保单状态
export const INSURANCE_STATUS = {
  '1': '已承保',
  '2': '已退保',
  '3': '已失败',
  '4': '到期失效'
}
// 最近浏览数据key名
export const DS_LOOK_HISTORY_KEY = `dsLookHistory${new Date().getFullYear()}${new Date().getMonth()}`
// export const DS_LOOK_HISTORY_KEY = 'dsLookHistory'
export const MIN_RESIDENCE_TIME = 2 * 1000 // 最短记录停留时间
// 优享计划缓存key
export const ENJOY_THE_PLAN_KEY = 'enjoy_the_plan_flag'

// 各个渠道的顶部跳转链接
export const GLOBAL_TITLEBAL_LINKTO = {
  // 袋鼠渠道
  '0': {
    usercenter: '/user-center',
    index: '/',
    collection: '/collection'
  },
  // 好医生渠道
  '1': sessionStorage.getItem("card") === "2" ? {
    index: '/doctor-card-two',
    usercenter: '/doctor-card-center'
  } : {
    index: '/',
  },
  '2': {
    usercenter: '/user-center',
  },
}

export const NEW_ORDER_STATUS = {
  // 2: '待付款',
  3: '使用中',
  5: '已赠送',
  6: '已过期',
  7: '已失效',
  9: '退款成功', // 专属  卡订单
  10: '已取消',
  // 15: '待预约'
  // 18: '退款中',
  19: '退款成功',
  // 31: '待体检',
  32: '待取报告',
  33: '待评价',
  // 41: '已完成'
}

export const NEW_ORDER_CODE = {
  ALL: 1, // 全部
  WAIT_PAY: 2, // 待支付
  CANCELED: 10, // 已取消
  NO_SHOW: 12, // 爽约
  REVIEW_FAIL: 13, // 补检审核不通过
  PAY_TIMEOUT: 14, // 支付超时
  WAIT_RESERVE: 15, // 待预约
  REFUNDING: 18, // 退款中
  REFUND_SUCCESS: 19, // 已退款
  WAIT_EXAMINATION: 31, // 待体检
  WAIT_REPORT: 32, // 待报告
  WAIT_COMMENT: 33, // 待评价
  COMPLETE: 41, // 全部完成
  GROUP_BUY: 42 // 团购邀请
}

// 首页运营位
export const OPERATION = {
 default: [
    {
      name: "入职体检",
      avatar: require("@/assets/images/home/iocn_home_ruzhi_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/iocn_home_ruzhi_nor_zx.png"),
      route:
        "/package-list?packageNameLike=%E5%85%A5%E8%81%8C&activity_type=common",
    },
    {
      name: "男士体检",
      avatar: require("@/assets/images/home/icon_home_man_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_man_nor_zx.png"),
      route: "/package-list/?for_sex_list=1&sceneEntry=4",
    },
    {
      name: "女士体检",
      avatar: require("@/assets/images/home/icon_home_woman_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_woman_nor_zx.png"),
      route: "/package-list/?for_sex_list=2&sceneEntry=5",
    },
    {
      name: "父母体检",
      avatar: require("@/assets/images/home/icon_home_parents_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_parents_nor_zx.png"),
      route: "/package-list?package_class=6,7,42,126&sceneEntry=1",
    },
    {
      name: "高端体检",
      avatar: require("@/assets/images/home/icon_home_gaoduan_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_gaoduan_nor_zx.png"),
      route: "/package-list?package_class=129&sceneEntry=2",
    },
    {
      name: "职场体检",
      avatar: require("@/assets/images/home/icon_home_zhichang_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_zhichang_nor_zx.png"),
      route: "/package-list?package_class=2,127,129,147&sceneEntry=7",
    },
    {
      name: "基因检测",
      avatar: require("@/assets/images/home/icon_home_jiyin_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_jiyin_nor_zx.png"),
      route:
        "/package-list?package_custom_tags=153&sceneEntry=3",
    },
    // {
    //   name: "特惠体检",
    //   avatar: require("@/assets/images/home/icon_home_sale_nor@2x.png"),
    //   zx_avatar: require("@/assets/images/home/icon_home_sale_nor_zx.png"),
    //   route: "/common-activity/170?channel=006_31_0001_0001_00",
    // },
  ],
  '掌铁': [
    {
      name: "入职体检",
      avatar: require("@/assets/images/home/iocn_home_ruzhi_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/iocn_home_ruzhi_nor_zx.png"),
      route:
        "/package-list?packageNameLike=%E5%85%A5%E8%81%8C&activity_type=common",
    },
    {
      name: "男士体检",
      avatar: require("@/assets/images/home/icon_home_man_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_man_nor_zx.png"),
      route: "/package-list/?for_sex_list=1&sceneEntry=4",
    },
    {
      name: "女士体检",
      avatar: require("@/assets/images/home/icon_home_woman_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_woman_nor_zx.png"),
      route: "/package-list/?for_sex_list=2&sceneEntry=5",
    },
    {
      name: "父母体检",
      avatar: require("@/assets/images/home/icon_home_parents_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_parents_nor_zx.png"),
      route: "/package-list?package_class=6,7,42,126&sceneEntry=1",
    },
    {
      name: "高端体检",
      avatar: require("@/assets/images/home/icon_home_gaoduan_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_gaoduan_nor_zx.png"),
      route: "/package-list?package_class=129&sceneEntry=2",
    },
    {
      name: "职场体检",
      avatar: require("@/assets/images/home/icon_home_zhichang_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_zhichang_nor_zx.png"),
      route: "/package-list?package_class=2,127,129,147&sceneEntry=7",
    },
    {
      name: "热门体检",
      avatar: require("@/assets/images/home/icon_home_ermen_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_ermen_nor@2x.png"),
      route:
        "/package-org-list?type=package",
    },
    {
      name: "私人订制",
      avatar: require("@/assets/images/home/icon_home_dingzhi_nor@2x.png"),
      zx_avatar: require("@/assets/images/home/icon_home_dingzhi_nor@2x.png"),
      route: "/questionnaire/home",
    },
  ]
}
